var _a, _b;
import { __assign } from "tslib";
import { get, sum } from 'lodash';
import { RegionType, } from '@wix/shoutout-email-model-v3';
import { verifyOrFallbackTextColor } from '../../utils/verify-or-fallback';
import { toNormalizedHueSatBr } from '../../utils/color';
import { adjustImage } from '../../utils/adjust-image';
import { defaultTextColor, defaultTextSize } from '../../utils/defaults';
import * as cssUtils from '../../utils/css-utils';
import { getContentWidth } from '../../utils/get-message-width';
import { getFooterColumnsWidths } from './footer-utils';
var nameToMobileSrc = (_a = {},
    _a["facebook" /* SocialNetwork.facebook */] = 'a306cb_3a0dee121d084f3e8e9aac9a7be7fbd7~mv2.png',
    _a["pinterest" /* SocialNetwork.pinterest */] = 'a306cb_b69aa15596b64fdfb581bce8827e8f9a~mv2.png',
    _a["twitter" /* SocialNetwork.twitter */] = 'a306cb_467f15ca1ece4d0ba5547b7489e345e5~mv2.png',
    _a);
var nameToAltTextKey = (_b = {},
    _b["facebook" /* SocialNetwork.facebook */] = 'COMPOSER.FOOTER.ALT.SHARE_VIA_FACEBOOK',
    _b["pinterest" /* SocialNetwork.pinterest */] = 'COMPOSER.FOOTER.ALT.SHARE_VIA_PINTEREST',
    _b["twitter" /* SocialNetwork.twitter */] = 'COMPOSER.FOOTER.ALT.SHARE_VIA_TWITTER',
    _b);
var mySiteIconSrc = 'b49ee3_dd9b1a8812ae41138409a667954a6088~mv2.png';
var mySiteIconRtlSrc = 'a306cb_b5f719a9248c4930a356a660d73e14c1~mv2.png';
var mobilePlaceIconSrc = 'a306cb_c4f51e285cc7410f90c33964096d466c~mv2.png';
var isVisibleBusinessDetailsSection = function (_a) {
    var address = _a.address, phone = _a.phone;
    return (address.active && !!address.text.length) ||
        (phone.active && !!phone.text.length);
};
var isVisibleSocialIconsSection = function (_a) {
    var active = _a.active;
    return active;
};
var isVisibleTitleSection = function (_a) {
    var active = _a.active, url = _a.url;
    return active && !!(url === null || url === void 0 ? void 0 : url.length);
};
var isVisibleMobilePlacePromo = function (mobilePlacePromo) { var _a; return (_a = mobilePlacePromo === null || mobilePlacePromo === void 0 ? void 0 : mobilePlacePromo.active) !== null && _a !== void 0 ? _a : false; };
export var getFooterSection = function (_a) {
    var css = _a.css, isRtl = _a.isRtl, lpProps = _a.lpProps, region = _a.region, composerData = _a.composerData;
    if (region.type !== RegionType.Footer) {
        throw Error('Footer must be passed');
    }
    var _b = region.data, businessDetails = _b.businessDetails, socialButtons = _b.socialButtons, siteTitle = _b.siteTitle, mobilePlacePromo = _b.mobilePlacePromo;
    var visibleBusinessDetails = isVisibleBusinessDetailsSection(businessDetails);
    var visibleSocialIcons = isVisibleSocialIconsSection(socialButtons);
    var visibleSiteTitle = isVisibleTitleSection(siteTitle);
    var visibleMobilePlacePromo = isVisibleMobilePlacePromo(mobilePlacePromo);
    if (!visibleBusinessDetails &&
        !visibleSocialIcons &&
        !visibleSiteTitle &&
        !visibleMobilePlacePromo) {
        return null;
    }
    var footerIconColor = verifyOrFallbackTextColor(get(css, 'so-global-footer-icon.fill'));
    var _c = toNormalizedHueSatBr(footerIconColor), br = _c.br, hue = _c.hue, sat = _c.sat;
    // NOTE: Make sure that ImageWithLoader from composer still works if you change this.
    var imageProps = {
        w: 750,
        h: 750,
        // FYI: adding params in different order might cause different result;
        br: br,
        sat: sat,
        hue: hue,
        lg: 0,
    };
    // NOTE: Make sure that ImageWithLoader from composer still works if you change this.
    var mobileImageProps = {
        w: 36,
        h: 36,
        // FYI: adding params in different order might cause different result;
        br: br,
        sat: sat,
        hue: hue,
        lg: 0,
    };
    var mobilePlaceIconUrlQuery = adjustImage(mobilePlaceIconSrc, mobileImageProps);
    var buttons = socialButtons.buttons
        .filter(function (_a) {
        var active = _a.active;
        return active;
    })
        .map(function (_a) {
        var name = _a.name, url = _a.url;
        return ({
            src: adjustImage(nameToMobileSrc[name], imageProps),
            alt: nameToAltTextKey[name],
            link: url,
            name: name,
        });
    });
    var goToSiteImageSrc = isRtl ? mySiteIconRtlSrc : mySiteIconSrc;
    var separatorColor = (get(css, 'so-global-footer-separator.borderColor') ||
        defaultTextColor);
    var rules = [css['so-global-region-footer'], css['so-global-region']];
    var mobileCssClass = cssUtils.getRegionMobileCssClass(rules);
    var innerPadding = cssUtils.padding(rules);
    var columnCount = sum([visibleBusinessDetails, visibleSocialIcons, visibleSiteTitle].map(Boolean));
    var contentWidth = getContentWidth(composerData, css, rules) -
        (innerPadding.left || 0) -
        (innerPadding.right || 0) -
        (columnCount - 1); // borders between columns
    var columnsProportions = Array.from({ length: columnCount }, function () { return 100 / columnCount; });
    var columnsWidths = cssUtils.calculateColumnsProportions(contentWidth, columnsProportions, innerPadding, isRtl);
    var _d = getFooterColumnsWidths(columnsWidths, visibleBusinessDetails, visibleSocialIcons, visibleSiteTitle), businessColumnWidth = _d.businessColumnWidth, socialColumnWidth = _d.socialColumnWidth, titleWidth = _d.titleWidth;
    var isSocialButtonsFirst = !visibleBusinessDetails && visibleSocialIcons;
    var isSiteTitleFirst = !visibleBusinessDetails && !isSocialButtonsFirst && visibleSiteTitle;
    var isSocialButtonsLast = !visibleSiteTitle && visibleSocialIcons;
    var isBusinessDetailsLast = !visibleSiteTitle && !isSocialButtonsLast && visibleBusinessDetails;
    var rightPadding = "".concat(innerPadding.right, "px");
    var leftPadding = "".concat(innerPadding.left, "px");
    return {
        widthsForMediaQueries: [businessColumnWidth, socialColumnWidth, titleWidth],
        businessDetails: {
            address: getAddress(),
            phone: getPhone(),
            isVisible: visibleBusinessDetails,
            showBorderLeft: false,
            showBorderRight: false,
            width: businessColumnWidth,
            paddingLeft: businessPaddingLeft(),
            paddingRight: businessPaddingRight(),
        },
        socialButtons: {
            buttons: buttons,
            isVisible: visibleSocialIcons,
            shareViaTitle: socialButtons.shareViaTitle,
            showBorderLeft: visibleBusinessDetails && separatorColor !== 'transparent',
            showBorderRight: visibleSiteTitle && separatorColor !== 'transparent',
            showCustomShareViaTitle: typeof socialButtons.shareViaTitle === 'string',
            width: socialColumnWidth,
            paddingLeft: socialPaddingLeft(),
            paddingRight: socialPaddingRight(),
        },
        siteTitle: {
            text: siteTitle.text,
            url: siteTitle.url,
            isVisible: visibleSiteTitle,
            showBorderLeft: visibleBusinessDetails &&
                !visibleSocialIcons &&
                separatorColor !== 'transparent',
            showBorderRight: false,
            hasTopDivider: !visibleSocialIcons,
            iconSrc: adjustImage(goToSiteImageSrc, imageProps),
            isRtl: isRtl,
            width: titleWidth,
            paddingLeft: titlePaddingLeft(),
            paddingRight: titlePaddingRight(),
        },
        mobilePlacePromo: __assign(__assign({}, getMobilePlacePromo()), { isVisible: visibleMobilePlacePromo, iconSrc: mobilePlaceIconUrlQuery }),
        textColor: verifyOrFallbackTextColor(get(css, 'so-global-footer-text.color')),
        separatorColor: separatorColor,
        fontSize: (get(css, 'so-global-footer-text.fontSize') ||
            defaultTextSize),
        showAd: lpProps.showAd,
        outerPadding: cssUtils.margin(rules),
        innerPadding: innerPadding,
        cssClass: mobileCssClass,
    };
    function businessPaddingLeft() {
        if (isRtl) {
            return isBusinessDetailsLast ? leftPadding : '0px';
        }
        else {
            return leftPadding;
        }
    }
    function businessPaddingRight() {
        if (isRtl) {
            return rightPadding;
        }
        else {
            return isBusinessDetailsLast ? rightPadding : '0px';
        }
    }
    function socialPaddingLeft() {
        if (isRtl) {
            return isSocialButtonsLast ? leftPadding : '0px';
        }
        else {
            return isSocialButtonsFirst ? leftPadding : '0px';
        }
    }
    function socialPaddingRight() {
        if (isRtl) {
            return isSocialButtonsFirst ? rightPadding : '0px';
        }
        else {
            return isSocialButtonsLast ? rightPadding : '0px';
        }
    }
    function titlePaddingLeft() {
        if (isRtl) {
            return leftPadding;
        }
        else {
            return isSiteTitleFirst ? leftPadding : '0px';
        }
    }
    function titlePaddingRight() {
        if (isRtl) {
            return isSiteTitleFirst ? rightPadding : '0px';
        }
        else {
            return rightPadding;
        }
    }
    function getAddress() {
        return {
            active: businessDetails.address.active,
            href: businessDetails.address.url,
            text: businessDetails.address.text,
        };
    }
    function getPhone() {
        return {
            active: businessDetails.phone.active,
            href: businessDetails.phone.url,
            text: businessDetails.phone.text,
        };
    }
    function getMobilePlacePromo() {
        return mobilePlacePromo
            ? {
                title: mobilePlacePromo.title,
                cta: mobilePlacePromo.cta,
                ctaUrl: mobilePlacePromo.ctaUrl,
            }
            : {};
    }
};
export var isFooterHidden = function (composerData) {
    var region = composerData.regions.find(function (r) { return r.type === RegionType.Footer; });
    if (!region) {
        return true;
    }
    var _a = region.data, socialButtons = _a.socialButtons, businessDetails = _a.businessDetails, siteTitle = _a.siteTitle, mobilePlacePromo = _a.mobilePlacePromo;
    var visibleBusinessDetails = isVisibleBusinessDetailsSection(businessDetails);
    var visibleSocialIcons = isVisibleSocialIconsSection(socialButtons);
    var visibleSiteTitle = isVisibleTitleSection(siteTitle);
    var visibleMobilePlacePromo = isVisibleMobilePlacePromo(mobilePlacePromo);
    return (!visibleBusinessDetails &&
        !visibleSocialIcons &&
        !visibleSiteTitle &&
        !visibleMobilePlacePromo);
};
//# sourceMappingURL=get-footer-section.js.map